export const firebaseConfig = {
  apiKey: 'AIzaSyDpg80CKfqVpsP-QIe9CdIppeYQs7ApVBU',
  authDomain: 'finance-tracker-app-reac-1725e.firebaseapp.com',
  projectId: 'finance-tracker-app-reac-1725e',
  storageBucket: 'finance-tracker-app-reac-1725e.appspot.com',
  messagingSenderId: '602775424709',
  appId: '1:602775424709:web:f5995f3804c6fb78e06aac',
};
